//import actions from 'store/actions';
import currency from '@synergycms_core/store/customer/currencyAction';

import customerActions from '@synergycms_core/store/customer/customerActions';

export default {
  ...customerActions,
  ...currency,
  CURRENT_CURRENCY: {
    SET: (currencyCode) => {
      return (dispatch, getState) => {
        let finalCurrency;
        const store = getState();
        const currencies = store.getIn(['customer', 'currencies']);

        const validateCurrency = currencyCode => currencies.find(c => currencyCode === c.get('code'));
        const hotels = store.getIn(['hotels', 'hotels_info', 'hotels']);
        const params = store.getIn(['customer', 'params', 'avail_cache_params']);
        if (currencyCode && validateCurrency(currencyCode)) {
          finalCurrency = currencyCode;
        } else if(hotels && params) {
          //date: selected.start,
          //city_id: !hotelId && selected.country_id ? selected.id : null,
          //country_id: !selected.country_id && !selected.code ? selected.id : null,
          //hotelId: hotelId

          if (hotels && params) {
            const hotelId = params.get("hotelId");
            const cityId = params.get("city_id") ? +params.get("city_id") : null;
            const provinceId = params.get("province_id") ? +params.get("province_id") : null;
            const countryId = params.get("country_id") ? +params.get("country_id") : null;

            if (hotelId || cityId || provinceId || countryId) {
              for (let i = 0, len = hotels.size; !finalCurrency && i < len; i++) {
                const hotel = hotels.get(i);
                if (hotelId && hotel.get("id") === hotelId) {
                  currencyCode = hotel.get("currency_code");
                } else if (cityId && hotel.get("city_id") === cityId) {
                  currencyCode = hotel.get("currency_code");
                } else if (provinceId && hotel.get("province_id") === provinceId) {
                  currencyCode = hotel.get("currency_code");
                } else if (countryId && hotel.get("country_id") === countryId) {
                  currencyCode = hotel.get("currency_code");
                } else {
                  continue;
                }
                finalCurrency = validateCurrency(currencyCode) && currencyCode;
              }
            }

            if (!finalCurrency) {
              finalCurrency = "EUR";
            }
          }
        }
        return finalCurrency;
      };
    }
  }
};



